import {ReactNode} from 'react';
import { ClipLoader } from 'react-spinners';

interface LoaderProps {
  isRequesting: boolean,
  children?: ReactNode,
  text?: string,
}

const Loader = ({ isRequesting, text, children }: LoaderProps) => (
  <>
    {isRequesting ? (
      <div className="loading-circle-container center-loader">
        {text && <p style={{ whiteSpace: 'pre', textAlign: 'center' }}>{text}</p> }
        <div className="loading-circle">
          <ClipLoader id="_towngen-loader" />
        </div>
      </div>
    ) : null}
    {!isRequesting && children ? children : null}
  </>
);

export default Loader;
